<button nz-button nzType="default" nzShape="circle" [nzSize]="size" [style.backgroundColor]="_color" style="margin-right: 6px">
  <label [style.backgroundColor]="_color" [style.color]="'#000'">
    <i *ngIf="_icon" nz-icon [nzType]="_icon!"></i>
  </label>
</button>
